import { createContext } from 'react';
export const blackCardContext = createContext(null);
